'use client';

import { ContractDetail } from '@/components/ContractDetail';
import { SignersList } from '@/components/SignersList';

import { ContractItem } from '@/types';

interface Props {
  displayPassword?: string;
  showPassword?: (isShow: boolean) => void;
  contract: ContractItem;
  isVisualContractView?: boolean;
  onUserChange: (contractId: string) => void;
  onDownload: (id?: string) => void;
  viewMore?: () => void;
  hasMore?: boolean;
}

export function LefPanel(props: Props) {
  const { showPassword, contract, isVisualContractView, onUserChange, displayPassword, onDownload, viewMore, hasMore } =
    props;

  return isVisualContractView ? (
    <SignersList
      hasMore={hasMore}
      viewMore={viewMore}
      users={contract?.recipients || []}
      onDownload={onDownload}
      onUserChange={onUserChange}
      contract={contract}
    />
  ) : (
    <div className="w-[352px] pl-10 pt-8 h-full relative flex flex-col pb-[100px] overflow-auto border-r border-gray-200">
      <div className="text-lg font-bold text-gray-900">Document Details</div>
      <ContractDetail
        hasMore={hasMore}
        viewMore={viewMore}
        showPassword={showPassword}
        password={displayPassword}
        className="mt-4 pr-10"
        contract={contract}
      ></ContractDetail>
    </div>
  );
}
